import BaseService from "./baseService";
import { reloadBrands } from "../redux/actions/index";

export class BrandService extends BaseService {
  constructor(base) {
    super(base);
    this.url = "/brands";
    this.name = "Brands";
    //this.BASE_URL = "http://localhost:4000";
    //this.BASE_URL = "http://34.123.161.156:4702";
  }
  picture(company) {
    return this.get('/brand/picture/' + company).then(function (data) {
      return data;
    });
  }
  getFullBrand(id) {
    let filter = {
      include: ["channel", "stores"]
    };
    return this.get(this.getIdUrl(id, filter));
  }
  Match(id){
    let answer = this.searchId(this.store.getState().brands, id);
    return answer
  }
  MatchName(id) {
    let answer = this.searchId(this.store.getState().brands, id);
    return answer ? answer.name : "-";
  }
  getCompanyBrand(id) {
    let filter = {
      where: {
        companyId: id
      }
    };
    return this.get(this.getUrl(filter));
  }
  reload() {
    let self = this;
    return this.read().then(function(data) {
      if (!data.hasOwnProperty("error")) {
        self.store.dispatch(reloadBrands(data));
      }
    });
  }
}

export default BrandService;
